module.exports = __webpack_public_path__ + "img/illustration-search.6e92bc23.svg";